import { Navigate } from "react-router";
import { useApp } from "../app-context.tsx";
import { Markdown } from "../markdown.tsx";

/** /privacy and /terms: the brand's `legal` text (localized), or home when the brand has none. */
export function LegalPage({ kind }: { kind: "privacy" | "terms" }) {
  const { brand } = useApp();
  const text = brand.config.legal?.[kind];
  if (!text) return <Navigate to="/" replace />;
  return (
    <article className="page page-legal">
      <Markdown text={text} />
    </article>
  );
}
